import { HONEYPOT_FIELD } from '@/lib/forms/spam';

/**
 * The honeypot: an input no person ever sees or tabs into, which bots fill
 * because it is in the form. Off-screen rather than display:none, since some
 * bots skip hidden inputs; excluded from the accessibility tree.
 *
 * Autofill must never touch it, or a real lead is quarantined. Its name and
 * label mean nothing a password manager or Safari AutoFill could match
 * ("Website" did), and the data attributes opt it out of 1Password
 * (data-1p-ignore), LastPass (data-lpignore), Bitwarden (data-bwignore) and
 * Dashlane (data-form-type="other"). The route treats any value as spam
 * (src/lib/forms/spam.ts).
 */
export function HoneypotField() {
  return (
    <div aria-hidden="true" style={{ position: 'absolute', left: '-10000px', top: 'auto', width: '1px', height: '1px', overflow: 'hidden' }}>
      <label>
        Ref
        <input
          type="text"
          name={HONEYPOT_FIELD}
          tabIndex={-1}
          autoComplete="off"
          defaultValue=""
          data-1p-ignore=""
          data-lpignore="true"
          data-bwignore=""
          data-form-type="other"
        />
      </label>
    </div>
  );
}
